import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  // userSelector,
  // loginUser,
  // clearState,
  verifyCabinetToken,
} from "../features/main/mainSlice";
// import logoa from "../assets/logo.svg";
// import banner from "../assets/image_1.png";
// import AppModal from "../components/modal/MyModal";
// import { Footer } from "../Template";

const LoginByToken = () => {
  // const [showModalDialog, setShowModalDialog] = useState(false);
  // const { isFetching, isSuccess, message, errorMessage, myStatus, toVerify } =
  //   useSelector(userSelector);
  // const history = useHistory();
  const dispatch = useDispatch();

  const search = useLocation().search;

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    console.log("masuk login by token");

    const cabinetToken = searchParams.get("token");
    const params = {token: cabinetToken}
    dispatch(verifyCabinetToken(params))
  }, [search, dispatch]);

  return (
    <div>
      {/* <div className="mobile-hide">
        <div class="w-full grid grid-cols-2 gap-4 bg-white">
          <div className="grid grid-cols-1 gap-0 place-items-center h-screen ">
            <div className="login-box ">
              <div className="card  border-white">
                <div className="card-header text-center h1 text-red-500 text-lg bg-white border-white grid grid-cols-1 place-items-center">
                  <div style={{ width: "75%" }}>
                    <img src={logoa} />
                  </div>
                  <div>
                    <b>
                      <span className="text-merah-button font-bold text-lg">
                        Login
                      </span>
                    </b>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="show_hide h-auto overflow-hidden">
            <img src={banner} className="w-[100%] h-[100%]" />
          </div>
        </div>
      </div> */}

      {/* <div className="mobile-view mb-5 mt-4">
        <div class="w-full grid grid-cols-2 gap-4">
          <div className="col-span-2 lg:col-span-0 grid grid-cols-1 gap-0 place-items-center">
            <div className="login-box">
              <div className="card  border-white">
                <div className="card-header text-center h1 text-red-500 text-lg bg-white border-white mt-4">
                  <div class="grid grid-cols-1 place-items-center">
                    <img src={logoa} width="60%" />
                  </div>
                  <b>
                    <span className="text-merah-button font-bold text-lg">
                      Login
                    </span>
                  </b>
                </div>
                <div className="card-body">
                  {errorMessage ? (
                    <div
                      className="alert alert-sm"
                      style={{ backgroundColor: "#C2262C" }}
                    >
                      <button
                        onClick={hideAlert}
                        type="button"
                        className="close text-white"
                        data-dismiss="alert"
                        aria-hidden="true"
                        style={{ opacity: 1 }}
                      >
                        ×
                      </button>
                      <span className="text-bold text-white">
                        Error: {errorMessage}
                      </span>
                    </div>
                  ) : (
                    <p className="login-box-msg"></p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <Footer></Footer> */}
    </div>
  );
};

export default LoginByToken;
